import { Component, Inject, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatError } from '@angular/material/input';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { TranslatePipe } from '@ngx-translate/core';
import { API_PARAMS } from '../../../constants/api.constants';
import {
  AppointmentInfoField,
  BusinessCheckupSettingsRequest,
  PersonalCheckupSettingsRequest,
} from '../../../interfaces/appointment-info.model';
import { ModifyExamClothesDialogModel } from '../../../interfaces/dialogs/modify-exam-clothes-dialog.model';
import { AppointmentInfoService } from '../../../services/appointment-info.service';
import { SharedStorageService } from '../../../services/shared-storage.service';
import { ID_LOGIN_TYPE } from '../../../constants/common.constants';
import { ExamItemName } from '../../../interfaces/reserve-confirm-survey.model';
import { AddExamInfo } from '../../../interfaces/reserve-add.model';

/**
 * 修改健檢服dialog組件
 */
@Component({
  selector: 'app-modify-exam-clothes-dialog',
  standalone: true,
  imports: [
    TranslatePipe,
    MatRadioGroup,
    MatRadioButton,
    FormsModule,
    MatButton,
    MatError,
  ],
  templateUrl: './modify-exam-clothes-dialog.component.html',
  styleUrl: './modify-exam-clothes-dialog.component.scss',
})
export class ModifyExamClothesDialogComponent implements OnInit {
  appointmentInfoService: AppointmentInfoService = inject(AppointmentInfoService);
  sharedStorageService: SharedStorageService = inject(SharedStorageService);

  clothesSizes: Array<AppointmentInfoField> = [];
  selectedClothesSize: string = '';
  showError: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ModifyExamClothesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModifyExamClothesDialogModel & { clothesSizes?: Array<AppointmentInfoField> }
  ) {
    this.selectedClothesSize = data.clothesSize;
    // 直接使用傳入的 clothesSizes
    this.clothesSizes = data.clothesSizes ?? [];
  }

  ngOnInit(): void {
    // 不需要再呼叫 API,因為 DialogHelperService 已經處理了
  }

  // 關閉dialog
  closeDialog() {
    this.dialogRef.close(null);
  }

  // 儲存修改
  onSubmit() {
    this.showError = true;
    if (this.selectedClothesSize) {
      const clothesSizeNoDesc =
        this.clothesSizes.find(item => item.uno === this.selectedClothesSize)?.noDesc ?? '';
      this.dialogRef.close({
        clothesSize: this.selectedClothesSize,
        clothesSizeNoDesc: clothesSizeNoDesc,
      } as ModifyExamClothesDialogModel);
    }
  }

  protected readonly API_PARAMS = API_PARAMS;
}
